export default __webpack_public_path__ + "static/media/transfer-postings.0b3257b2.svg";